module.exports = __webpack_public_path__ + "img/ni.a0057608.png";